// extracted by mini-css-extract-plugin
module.exports = {"desktopImg":"ImageItem_desktopImg__6JHxx","mobileImg":"ImageItem_mobileImg__8Y03Y","el":"ImageItem_el__A8HFD","imgSpan":"ImageItem_imgSpan__5qCZb"};